import $ from 'jquery';
import gsap from 'gsap';

$(() => {


  $('.navbar-collapse')
    .on('show.bs.collapse', function () {
      $('.navbar-toggler').not('.is-static').addClass('is-active')
      $('.navbar').addClass('is-activating')
    })
    .on('shown.bs.collapse', function () {
      $('.navbar').removeClass('is-activating')
      $('.navbar').addClass('is-active')
      $('body').addClass('locked')
    })
    .on('hide.bs.collapse', function () {
      $('.navbar').addClass('is-activating')
      $('.navbar-toggler').not('.is-static').removeClass('is-active')
    })
    .on('hidden.bs.collapse', function () {
      $('.navbar').removeClass('is-activating')
      $('.navbar').removeClass('is-active')
      $('body').removeClass('locked')
    });

  // Close the nav when a link is clicked on mobile.
  // Use jQuery collapse if available, otherwise try Bootstrap native API, then a safe manual fallback.
  $('.navbar-nav .nav-link, .navbar .btn-cta').on('click', function() {
    if (!isMobileNavActive()) return;

    const $collapse = $('.navbar-collapse');

    // nothing to do if not open
    if (!$collapse.hasClass('show')) return;

    // 1) jQuery collapse plugin (Bootstrap 3/4 with jQuery plugin)
    if (typeof $collapse.collapse === 'function') {
      $collapse.collapse('hide');
      return;
    }

    // 2) Bootstrap native API (Bootstrap 5)
    if (typeof bootstrap !== 'undefined' && bootstrap.Collapse) {
      const el = $collapse.get(0);
      let inst = bootstrap.Collapse.getInstance(el);
      if (!inst) inst = new bootstrap.Collapse(el, { toggle: false });
      inst.hide();
      return;
    }

    // 3) Fallback: remove classes and trigger hidden event so theme state updates
    $collapse.removeClass('show').trigger('hidden.bs.collapse');
    $('.navbar').removeClass('is-activating is-active');
    $('.navbar-toggler').not('.is-static').removeClass('is-active');
    $('body').removeClass('locked');
  });




  

  function isMobileNavActive() {
    var mobileNavBreakpoint = 992;
    if ($(window).width() < mobileNavBreakpoint) {
      return true;
    }
    return false;
  }




});